var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"without-overflow"},[_c('BeachImage'),_c('LinesMotorbike'),_c('PlayerConcurse'),_c('WinnersConcurse'),_c('FooterMatricula')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56f9d63e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BaseConcurso2020.vue
// module id = 2YZ0
// module chunks = 0